import React from 'react';
import { FormattedMessage } from 'react-intl';
import Notification from '../../../components/Notification';
import { getTime } from '../../../utils/TimeUtils';
import Misc from '../../../definitions/Misc';
import Api from '../../../api/Api';
import OTButton from '../../../components/tag/OTButton';

const { id: module_id } = module;

const UpdateUserInfoNotification = ({
  userInfo,
  updateUserInfo,
  contactFeatureOn,
}) => {
  const notifyUpdate = () => {
    if (!userInfo) {
      return false;
    }
    let lastUpdated = getTime(userInfo.userInfoTimestamp);
    let now = getTime();

    let compareTime = lastUpdated.add(...Misc.contactReminderInterval());
    return now.isAfter(compareTime);
  };

  const dismissUpdateNotification = (event) => {
    event.preventDefault();
    Promise.resolve(Api.dismissUpdateRequestNotification()).then(() => {
      updateUserInfo();
    });
  };

  return (
    notifyUpdate() && (
      <Notification>
        <FormattedMessage id={`${module_id}.update.contact.info.header`}>
          {(txt) => (
            <h2 style={{ lineHeight: '24px' }}>
              <i className="ot-notification__icon icon-user" />
              <span className="ot-notification__header">{txt}</span>
            </h2>
          )}
        </FormattedMessage>

        <div className="ot-notification__description">
          <p>
            <FormattedMessage id={`${module_id}.update.contact.info.body`} />
          </p>
          {contactFeatureOn && (
            <p>
              <FormattedMessage
                id={`${module_id}.update.contact.info.contacts`}
              />
            </p>
          )}
        </div>

        <OTButton
          onClick={dismissUpdateNotification}
          className="ot-notification__button"
        >
          <FormattedMessage id={'OK'} />
        </OTButton>
      </Notification>
    )
  );
};

export default UpdateUserInfoNotification;
